import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

export default function ProtectedRoute({ children, require }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ padding: 40, color: '#888' }}>Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;

  // email_verified false면 Home(/) 외 차단
  if (!user.email_verified && require) {
    return <Navigate to="/" replace />;
  }
  if (require === 'viewer' && !user.is_admin && user.access_level === 'NONE') {
    return <Navigate to="/" replace />;
  }
  if (require === 'admin' && !user.is_admin) {
    return <Navigate to="/" replace />;
  }
  return children;
}
